<div
    class="w-full grid lg:grid-cols-[2fr_1fr] grid-cols-1 gap-4 p-4 items-start"
    [formGroup]="form"
>
    <p-card>
        <div class="w-full flex flex-col gap-4">
            <h1 class="text-2xl font-bold">Editar Cliente</h1>

            <div
                class="w-full grid sm:grid-cols-12 grid-cols-1 gap-4 items-end"
            >
                <app-input-cpf-cnpj
                    label="CNPJ"
                    formControlName="CPF_CNPJ"
                    [row]="true"
                    class="sm:col-span-4"
                ></app-input-cpf-cnpj>

                <app-input
                    label="Razão Social"
                    formControlName="RAZAO_SOCIAL"
                    [row]="true"
                    class="sm:col-span-6"
                ></app-input>

                <app-select
                    [icon]="true"
                    [options]="status"
                    formControlName="STATUS"
                    label="Status"
                    class="sm:col-span-2"
                ></app-select>

                <app-input
                    id="nomefantasia"
                    formControlName="NOME_FANTASIA"
                    label="Nome de Fantasia"
                    class="sm:col-span-8"
                ></app-input>

                <app-input
                    id="inscEstadual"
                    formControlName="IE"
                    label="Insc. Estadual"
                    class="sm:col-span-4"
                ></app-input>

                <app-select
                    [icon]="true"
                    [options]="selectedRevenda"
                    formControlName="ID_REVENDA"
                    label="Revenda"
                    class="sm:col-span-5"
                ></app-select>

                <app-select
                    [icon]="true"
                    [options]="selectedRegimeTributario"
                    formControlName="REGIME_TRIBUTARIO"
                    label="Regime Tributário"
                    class="sm:col-span-4"
                ></app-select>

                <app-select
                    [icon]="true"
                    [options]="selectedVersaoSistema"
                    formControlName="VERSAO_SISTEMA"
                    label="Versão Sistema"
                    class="sm:col-span-3"
                ></app-select>

                <app-input
                    id="uri"
                    formControlName="URI"
                    label="Uri"
                    class="sm:col-span-6"
                ></app-input>

                <app-input
                    id="nomebanco"
                    formControlName="NOME_BANCO"
                    label="Nome Banco"
                    class="sm:col-span-3"
                ></app-input>

                <app-input
                    id="urldominio"
                    formControlName="UrlDominio"
                    label="Url Domínio"
                    class="sm:col-span-3"
                ></app-input>

                <app-input-cep
                    formControlName="CEP"
                    label="CEP"
                    class="sm:col-span-2"
                ></app-input-cep>

                <app-input
                    id="logradouro"
                    formControlName="ENDERECO"
                    label="Logradouro"
                    class="sm:col-span-6"
                ></app-input>

                <app-select
                    [icon]="true"
                    [options]="selectedHolding"
                    formControlName="ID_HOLDING"
                    label="Holding"
                    class="sm:col-span-4"
                ></app-select>

                <app-input
                    id="numero"
                    formControlName="NUMERO"
                    label="Número"
                    class="sm:col-span-2"
                ></app-input>

                <app-input
                    id="complemento"
                    formControlName="COMPLEMENTO"
                    label="Complemento"
                    class="sm:col-span-6"
                ></app-input>

                <app-select
                    [icon]="true"
                    [options]="selectedContador"
                    formControlName="IdContador"
                    label="Contador"
                    class="sm:col-span-4"
                ></app-select>

                <app-input
                    id="bairro"
                    formControlName="BAIRRO"
                    label="Bairro"
                    class="sm:col-span-5"
                ></app-input>

                <app-input
                    id="uf"
                    formControlName="UF"
                    label="UF"
                    class="sm:col-span-1"
                ></app-input>

                <app-input
                    id="cidade"
                    formControlName="CIDADE"
                    label="Cidade"
                    class="sm:col-span-3"
                ></app-input>

                <app-input
                    id="idempresa"
                    formControlName="ID_EMPRESA"
                    label="IdEmpresa"
                    class="sm:col-span-3"
                ></app-input>

                <app-input
                    id="email"
                    formControlName="EMAIL"
                    label="Email"
                    class="sm:col-span-6"
                ></app-input>

                <app-input-telefone
                    formControlName="CELULAR_CONTATO"
                    label="Contato"
                    class="sm:col-span-3"
                ></app-input-telefone>

                <app-input
                    id="qtdestacoes"
                    formControlName="QTD_ESTACOES"
                    label="Qtd Estações"
                    class="sm:col-span-3"
                ></app-input>

                <app-input-telefone
                    formControlName="TELEFONE"
                    label="Telefone"
                    class="sm:col-span-4"
                ></app-input-telefone>

                <app-input-telefone
                    formControlName="CELULAR"
                    label="Celular"
                    class="sm:col-span-4"
                ></app-input-telefone>

                <app-input
                    id="qtdcaixas"
                    formControlName="QTD_CAIXAS"
                    label="Qtd Caixas"
                    class="sm:col-span-4"
                ></app-input>

                <app-date
                    formControlName="DATA_ATIVACAO"
                    label="Data Ativação"
                    class="sm:col-span-3"
                ></app-date>

                <app-date
                    formControlName="DATA_DESATIVACAO"
                    label="Data Desativação"
                    class="sm:col-span-3"
                ></app-date>

                <app-date
                    formControlName="DATA_FIN"
                    label="Data Fim"
                    class="sm:col-span-3"
                ></app-date>

                <app-date
                    formControlName="DATA_BLOQUEIO"
                    label="Data Bloqueio"
                    class="sm:col-span-3"
                ></app-date>
            </div>

            <div
                class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
            >
                <app-button
                    variant="danger"
                    (click)="cancelar()"
                    class="md:max-w-45 w-full"
                    >Cancelar</app-button
                >

                <app-button
                    variant="success"
                    (click)="processarFormulario()"
                    class="md:max-w-45 w-full"
                    >Salvar</app-button
                >
            </div>
        </div>
    </p-card>

    <p-card>
        <div
            class="w-full grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-2 grid-cols-1 gap-4 items-end"
        >
            <app-select-button
                formControlName="ControleEstoque"
                [label]="'Controle de estoque'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="ControleFinanceiro"
                [label]="'Controle financeiro'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="Planejamento"
                [label]="'Planejamento'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="AnalisadorTributario"
                [label]="'Analisador tributario'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="SimuladorPromocao"
                [label]="'Simulador promoção'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="ConciliadorCartao"
                [label]="'Conciliador de cartão'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="HubIntegracao"
                [label]="'Hub Integração'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="Bi"
                [label]="'Bi'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="Scanntech"
                [label]="'Scanntech'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="Contabil"
                [label]="'Contabil'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="AppCCI"
                [label]="'AppCCI'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="BalancoPatrimonial"
                [label]="'Balanço Patrimonial'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="EmissaoMDFe"
                [label]="'Emissao MDFe'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="EmissaoCte"
                [label]="'Emissao Cte'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="IntegradoImendes"
                [label]="'Imendes'"
                [options]="stateOptions"
            ></app-select-button>

            <app-select-button
                formControlName="IntegradoMandei"
                [label]="'Mandei App'"
                [options]="stateOptions"
            ></app-select-button>
        </div>
    </p-card>
</div>
